class Controller {
  constructor(Events) {
    "ngInject";

    this.Events = Events;
  }
  $onInit() {
    this.enableField = () => {
      this.selected.isDisabled = false;
    };
    this.submitField = () => {
      this.selected.name = this.name || this.selected.key;
      this.selected.methodName = this.resourceMethodName;
      const options = Object.assign({}, this.selected);
      if (this.extraParams) options.extraParams = this.extraParams;
      this.Events.emit(this.eventName, options);
    };
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/editableCheckbox/editableCheckbox.controller.js